import { render } from "./AllChainsList.vue?vue&type=template&id=236f6abf&scoped=true"
import script from "./AllChainsList.vue?vue&type=script&lang=js"
export * from "./AllChainsList.vue?vue&type=script&lang=js"

import "./AllChainsList.vue?vue&type=style&index=0&id=236f6abf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236f6abf"]])

export default __exports__